// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "vendors-13b5c77a0cc2e073be9a.js";
	// return url for filenames based on template
	return "" + ({"806":"__federation_expose_routes","943":"__federation_expose_handlers"}[chunkId] || chunkId) + "-" + {"200":"bfe11c7fb8eaba8c4d4c","490":"9fcd65f5e87df691c1b8","529":"423d1cd2053b3daab08b","666":"285db71ae74d0f0b1edd","806":"03a2aea272cc456495ca","868":"5ed9b47ea28b41aece7d","943":"857ba352e257d258b282"}[chunkId] + ".js";
};